/**
 * @generated SignedSource<<bee05a671b875cf8539f22a950b0de91>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef$data = {
  readonly jiraAssignability?: {
    readonly isAssignable: boolean | null;
  } | null;
  readonly permissions?: {
    readonly canEdit: boolean;
  } | null;
  readonly " $fragmentType": "agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef";
};
export type agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef$key = {
  readonly " $data"?: agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "enableJiraAgentFields"
    }
  ],
  "kind": "Fragment",
  "name": "agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef",
  "selections": [
    {
      "condition": "enableJiraAgentFields",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "AgentStudioAgentPermissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canEdit"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraAgentAssignability",
          "kind": "LinkedField",
          "name": "jiraAssignability",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isAssignable"
            }
          ]
        }
      ]
    }
  ],
  "type": "AgentStudioAssistant"
};

(node as any).hash = "4b56ca78e67bff86ebe2e162097e262a";

export default node;
